import {Component, Input} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {DRM_STREAMTYPES} from './encoding-ladder.model';

/**
 * What is wrong with the DRM width tiers as a set. These rules span tiers (order, bounds), so no
 * single row owns them: the DRM card shows them, and so does the dialog that is changing a tier.
 */
@Component({
  selector: 'app-drm-errors',
  template: `
    @if (errors?.noTiers) {
      <p class="invalid-feedback d-block">A video ladder needs at least one width tier besides AUDIO.</p>
    }
    @if (errors?.tierOrder || errors?.duplicateTier) {
      <p class="invalid-feedback d-block">
        Declare tiers ascending and once each, in the order {{ streamTypes.join(', ') }}.
      </p>
    }
    @if (errors?.tierWidth) {
      <p class="invalid-feedback d-block">A tier's max width must be at least 1.</p>
    }
    @if (errors?.tierAscending || errors?.tierUnbounded) {
      <p class="invalid-feedback d-block">Every bounded tier needs a max width, and they must strictly ascend.</p>
    }
  `,
})
export class DrmErrorsComponent {
  @Input() errors: ValidationErrors | null = null;
  readonly streamTypes = DRM_STREAMTYPES;
}
